<template>
  <div id="container">
    <h1 class="u-link-white" href="#">{{ timeFormatted }}</h1>
    <h2>Before the exam shall start.</h2>
  </div>
</template>

<script>
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment";
import { compareAsc, format, formatDistance, subDays } from "date-fns";
Vue.use(require("vue-moment"));

export default {
  el: "div",
  data() {
    return {
      time: 0,
      isRunning: false,
      interval: null,
      timeFormatted: "",
      momentObject: moment(this.time),
    };
  },
  methods: {
    incrementTime() {
      let finalDate = new Date("5/6/2021 13:00:00");
      let current = new Date();
      let distance = new Date(finalDate.getTime() - current.getTime());

      this.timeFormatted =
        formatDistance(current, finalDate, {
          includeSeconds: true,
        }) +
        `, ${distance.getHours()} hours, ${distance.getMinutes()} minutes, and ${distance.getSeconds()} seconds`;
    },
  },
  created() {
    this.incrementTime();
    this.time = Date.now();
    if (this.isRunning) {
      clearInterval(this.interval);
    } else {
      this.interval = setInterval(this.incrementTime, 1000);
    }
    this.isRunning = !this.isRunning;
  },
};
</script>

<style scoped>
h2 {
  color: lightgrey;
}
h1 {
  margin-top: 0;
  font-size: 50px;
}
</style>